/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

import { Injector } from '@angular/core';

import { DnsPolicyCollection } from 'ajs/modules/dns/factories/dns-policy.collection.factory';
import { DNS_POLICY_COLLECTION_TOKEN } from 'ajs/modules/dns/dns.tokens';
import { StringGroupCollection }
    from 'ajs/modules/groups/factories/string-group/string-group.collection.factory';
import { STRING_GROUP_COLLECTION_TOKEN } from 'ajs/modules/groups/groups.tokens';

const $injector = '$injector';

export const dnsPolicyCollectionProvider = {
    deps: [$injector],
    provide: DnsPolicyCollection,
    useFactory(injector: Injector): typeof DnsPolicyCollection {
        return injector.get(DNS_POLICY_COLLECTION_TOKEN);
    },
};

export const stringGroupCollectionProvider = {
    deps: [$injector],
    provide: StringGroupCollection,
    useFactory(injector: Injector): typeof StringGroupCollection {
        return injector.get(STRING_GROUP_COLLECTION_TOKEN);
    },
};

export const gslbCollectionProvider = {
    deps: [$injector],
    provide: 'GSLBCollection',
    useFactory(injector: Injector): any {
        return injector.get('GSLBCollection');
    },
};
